<template>
  <Index></Index>
</template>

<script>
import Index from './pages/index/index'

export default {
  name: 'App',
  components: {
    Index
  }
}
</script>

<style>
#app {
  font-family: ui-rounded,SF Pro Rounded,SF Pro Text,medium-content-sans-serif-font,-apple-system,BlinkMacSystemFont,ui-sans-serif,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #080808;
  background: #F8F8F8
}

</style>
